var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('m-edit-instant-dialog',{ref:"dialog",attrs:{"title":"Select Training Date and Time","value":_vm.value,"optional":_vm.optional,"timezone":_vm.timezone},on:{"ok":function($event){return _vm.onSet($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }